import { Moment } from 'moment';

export type TimeUnit = {
  apiValue: number;
  label: string;
  asDate: Moment;
};
